import { Select } from '@mantine/core'

import { useQuery } from '@redwoodjs/web'

import { toast } from 'src/components/Overlays/Toast/Toast'
import { GET_DOCUMENT_TEMPLATE_PACKAGES } from 'src/graphql/documentTemplatePackages.graphql'
import { formatSnakeValue } from 'src/lib/formatters'

import { inlineSelectProps } from './inlineSelectStyles'

const DocumentPackageOptions = ({
  selectedDocumentTemplatePackage,
  setSelectedDocumentTemplatePackage,
}) => {
  const { data: documentTemplates } = useQuery(GET_DOCUMENT_TEMPLATE_PACKAGES, {
    onError: () => {
      toast(
        'Unable to get document template packages, please try again.',
        'error'
      )
    },
  })

  const packagesList =
    documentTemplates?.documentTemplatePackages?.map(
      (documentTemplatePackage) => ({
        value: documentTemplatePackage.documentTemplatePackageId,
        label: `${formatSnakeValue(documentTemplatePackage.packageName)}`,
        documentTemplatePackage,
      })
    ) || []

  return (
    <div className="flex flex-col gap-3 text-xs">      {packagesList.length === 0 ? (
        <div className="text-xs text-doubleNickel-gray-500">
          No document template packages found.
        </div>
      ) : (
        <Select
          {...inlineSelectProps}
          value={selectedDocumentTemplatePackage?.documentTemplatePackageId}
          onChange={(value) =>
            setSelectedDocumentTemplatePackage({
              documentTemplatePackageId: value,
            })
          }
          data={packagesList}
          searchable
          className="max-w-sm"
        />
      )}
    </div>
  )
}

export default DocumentPackageOptions
